<template>
  <div style="height:100%;">
    <el-card class="task-nav title-task-nav">
      <span>{{$route.meta.parent}}</span>
      <span>/</span>
      <span>{{$route.params.type=="all"?"全部任务":$route.params.type=="run"?"正在运行":$route.params.type=="wait"?"正在等待":$route.params.type=="success"?"已完成":$route.params.type=="cancel"?"已取消":$route.params.type=="error"?"错误":""}}</span>
      <div class="refresh-box" v-if="$route.params.type=='run'">
        <el-link :underline="false">开启实时刷新</el-link>
        <el-switch v-model="refreshType" active-color="#13ce66" @change="refreshFun"></el-switch>
      </div>
    </el-card>
    <el-card class="box-card page-box-card">
      <div class="all-bar">
        <div>
          <el-link
            :underline="false"
            :disabled="false"
            type="info"
            @click="$router.push('/index/task/addTask')"
          >
            <span class="el-icon-plus"></span>
            <span>添加</span>
          </el-link>
          <el-link
            :underline="false"
            :disabled="selectionData.length==0"
            type="info"
            @click="deleteFormatFun(selectionData)"
          >
            <span class="el-icon-delete"></span>
            <span>删除</span>
          </el-link>
          <el-link
            :underline="false"
            :disabled="selectionData.length==0"
            type="info"
            v-if="$route.params.type=='cancel' || $route.params.type=='error'"
            @click="retryTaskFun(selectionData)"
          >
            <span class="el-icon-refresh-left"></span>
            <span>重试</span>
          </el-link>
          <el-link
            :underline="false"
            :disabled="selectionData.length==0"
            type="info"
            v-if="$route.params.type=='run' || $route.params.type=='wait'"
            @click="cancelTaskFun(selectionData)"
          >
            <span class="el-icon-remove-outline"></span>
            <span>取消</span>
          </el-link>
        </div>
        <el-input
          placeholder="搜索"
          suffix-icon="el-icon-search"
          v-model="task_name"
          size="mini"
          style="width:266px"
          @change="getListFun"
        ></el-input>
      </div>
      <el-table
        :data="pageList"
        height="100%"
        @row-click="clickRow"
        ref="moviesTable"
        @selection-change="selectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="task_name" label="任务名称"></el-table-column>
        <el-table-column label="任务类型">
          <template
            slot-scope="{row}"
          >{{row.task_type=="transvideo"?"视频转码":row.task_type=="firstpic"?"视频抽取首帧":row.task_type=="cutvideo"?"视频截取片段":row.task_type=="cutpic"?"视频截取图片":row.task_type=="mp4tots"?"视频流化":row.task_type=="tstomp4"?"流化合成":row.task_type=="transpic"?"图片转码":row.task_type=="transfile"?"文档转码":""}}</template>
        </el-table-column>
        <el-table-column label="任务状态" v-if="$route.params.type=='run'">
          <template slot-scope="{row}">
            <el-progress :text-inside="true" :stroke-width="14" :percentage="row.task_progress"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="任务状态" v-else>
          <template slot-scope="{row}">
            <el-link
              :underline="false"
              :type="row.task_status=='正在运行'?'primary':row.task_status=='等待'?'info':row.task_status=='完成'?'success':row.task_status=='取消'?'warning':'danger'"
            >{{row.task_status}}</el-link>
            <el-popover
              placement="top-start"
              title="错误原因"
              width="200"
              trigger="hover"
              v-if="row.task_status=='错误'"
              :content="row.task_remark"
            >
              <el-button
                icon="el-icon-warning-outline"
                circle
                size="mini"
                slot="reference"
                class="danger-msg"
              ></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
        <el-table-column prop="task_time_start" label="开始时间"></el-table-column>
        <el-table-column prop="task_times" label="耗时"></el-table-column>
        <el-table-column label="操作" width="50px" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="$router.push(`/index/task/detailsTask/${row.task_type}/${row.task_id}`)"
                >详情</el-dropdown-item>
                <el-dropdown-item
                  @click.native="cancelTaskFun([row])"
                  v-if="$route.params.type=='run' || $route.params.type=='wait'"
                >取消</el-dropdown-item>
                <el-dropdown-item
                  @click.native="retryTaskFun([row])"
                  v-if="$route.params.type=='cancel' || $route.params.type=='error'"
                >重试</el-dropdown-item>
                <el-dropdown-item @click.native="deleteFormatFun([row])">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 40, 50]"
        :current-page="pageIndex"
        @current-change="currentChangeFun"
        @size-change="sizeChange"
        :hide-on-single-page="true"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      selectionData: [],
      refreshType: false
    };
  },
  computed: {
    ...mapState("task", ["pageList", "total", "getListData", "loading"]),
    task_name: {
      get() {
        return this.$store.state.task.getListData.task_name;
      },
      set(value) {
        this.setListData({ task_name: value });
      }
    },
    pageIndex: {
      get() {
        return this.$store.state.task.getListData.pageIndex;
      },
      set(value) {
        this.setListData({ pageIndex: value });
      }
    }
  },
  created() {
    this.$route.params.type == "all"
      ? (document.title = "全部任务")
      : this.$route.params.type == "run"
      ? (document.title = "正在运行")
      : this.$route.params.type == "wait"
      ? (document.title = "正在等待")
      : this.$route.params.type == "success"
      ? (document.title = "已完成")
      : this.$route.params.type == "cancel"
      ? (document.title = "已取消")
      : this.$route.params.type == "error"
      ? (document.title = "错误")
      : "";
    this.getListFun();
  },
  beforeRouteUpdate(to, from, next) {
    this.refreshType = false;
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.refreshType = false;
    next();
  },
  methods: {
    ...mapActions("task", [
      "getTaskListSto",
      "deleteTaskSto",
      "cancelTaskSto",
      "retryTaskSto"
    ]),
    ...mapMutations("task", ["setListData"]),
    // 页面变化
    currentChangeFun(val) {
      this.setListData({ pageIndex: val });
      this.getListFun();
    },
    // size变化
    sizeChange(val) {
      this.setListData({ pageSize: val });
      this.getListFun();
    },
    //搜索变化
    nameChange() {},
    // 选中行
    clickRow(row) {
      this.$refs.moviesTable.toggleRowSelection(row);
    },
    //获取列表
    getListFun() {
      return this.getTaskListSto(this.$route.params.type);
    },
    // 选中改变
    selectionChange(val) {
      this.selectionData = val;
    },
    // 删除
    deleteFormatFun(list) {
      let delete_status = 0;
      this.$route.params.type == "run"
        ? (delete_status = 2)
        : this.$route.params.type == "wait"
        ? (delete_status = 1)
        : this.$route.params.type == "success"
        ? (delete_status = 5)
        : this.$route.params.type == "cancel"
        ? (delete_status = 4)
        : this.$route.params.type == "error"
        ? (delete_status = 3)
        : "";
      let data = { delete_json: "" };
      let delete_jsonArr = [];
      list.forEach((val, ind) => {
        delete_jsonArr.push({
          task_id: val.task_id,
          delete_status: delete_status
        });
      });
      data.delete_json = JSON.stringify(delete_jsonArr);
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteTaskSto(data).then(({ data }) => {
            if (data.status == 0) {
              this.$message.success("删除成功");
              this.getListFun();
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 取消任务
    cancelTaskFun(list) {
      let cancel_status = 0;
      this.$route.params.type == "run"
        ? (cancel_status = 2)
        : this.$route.params.type == "wait"
        ? (cancel_status = 1)
        : this.$route.params.type == "success"
        ? (cancel_status = 4)
        : this.$route.params.type == "cancel"
        ? (cancel_status = 5)
        : this.$route.params.type == "error"
        ? (cancel_status = 3)
        : "";
      let data = { cancel_json: "" };
      let cancel_jsonArr = [];
      list.forEach((val, ind) => {
        cancel_jsonArr.push({
          task_id: val.task_id,
          cancel_status: cancel_status
        });
      });
      data.cancel_json = JSON.stringify(cancel_jsonArr);
      this.$confirm("此操作将取消该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.cancelTaskSto(data).then(({ data }) => {
            if (data.status == 0) {
              this.$message.success("取消成功");
              this.getListFun();
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //重试任务
    retryTaskFun(list) {
      let ids = list.map(val => {
        return val.task_id;
      });
      let data = { task_id: ids.join(",") };
      this.$confirm("此操作将重试该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.retryTaskSto(data).then(({ data }) => {
            if (data.status == 0) {
              this.$message.success("重试成功");
              this.getListFun();
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 实时刷新
    refreshFun() {
      if (this.refreshType) {
        setTimeout(() => {
          this.getListFun().then(() => {
            if (this.pageList.length > 0 && this.refreshType) {
              this.refreshFun();
            }
          });
        }, 2000);
      }
    }
  }
};
</script>


<style scoped>
.all-bar {
  height: 28px;
  display: flex;
  justify-content: space-between;
}
.all-bar > div:nth-child(1) {
  height: 28px;
  display: flex;
}
.all-bar > div:nth-child(1) a {
  display: flex;
  margin-right: 20px;
}
.all-bar > div:nth-child(1) > span {
  height: 28px;
  line-height: 28px;
}
.refresh-box {
  float: right;
}
</style>
<style>
.danger-msg {
  background-color: transparent !important;
  border: none !important;
  font-size: 16px !important;
  /* width: 20px !important; */
  height: 20px !important;
  padding: 0 !important;
  color: #F56C6C !important;
  /* position: absolute; */
  /* top: 0; */
  /* left: 0; */
}
</style>